import React from 'react';

import { Flex } from '@chakra-ui/react';

function Accidents() {
  return <Flex data-id="eb0c6eb3ee05">Accidents</Flex>
}

export default Accidents;
